<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('consulting rooms')"
      :columns="columns"
      :column_search="true"
      resource_url="/patient/consulting-room/datatables"
      mode="grid"
      grid_class="is-col-min-10"
      :page_length="50"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
        <!-- <button class="button is-secondary is-rounded" @click="go_calendar">
          <span class="icon"><i class="fa fa-calendar"></i></span>
          <span>{{ $t("calendar") }}</span>
        </button> -->
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-info"
              :data-tooltip="$t('calendar')"
              @click="calendar(item)"
            >
              <span class="icon"><i class="fa fa-calendar"></i></span>
            </div>
            <!-- <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div> -->
            <figure class="image is-64x64 m-auto">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2799/2799363.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <div class="columns">
                  <div class="column">
                    <div class="title is-5 has-text-centered">
                      {{ item.name }}
                    </div>
                    <div class="subtitle is-6 has-text-centered mb-0">
                      {{ translate_status(item.status_code) }}
                    </div>
                    <div class="subtitle is-6 has-text-centered">
                      {{ item.location }}
                    </div>
                  </div>
                  <!-- <div class="column">
                    <div
                      class="media-right"
                      v-if="
                        item.patient_hospitalizations &&
                        item.patient_hospitalizations.length
                      "
                    >
                      <div
                        class="subtitle is-6 has-text-centered"
                        v-for="(hosp, hidx) in item.patient_hospitalizations"
                        :key="hidx"
                      >
                        <span class="icon has-text-success">
                          <i class="fa fa-check"></i>
                        </span>
                        <a :href="'/patient/' + hosp.patient.uuid"
                          ><span>{{ hosp.patient.name }}</span></a
                        >
                      </div>
                    </div>
                    <div v-else>
                      <div class="subtitle is-6 has-text-centered">
                        {{ $t("free") }}
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <consulting-room-modal ref="consulting_room_modal" @success="refresh" />
  <calendar-modal ref="calendar_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import ConsultingRoomModal from "./consulting_room_modal/Index.vue";
import CalendarModal from "./consulting_room_calendar_modal/Index.vue";

export default {
  name: "PatientDatatable",
  components: { GenericTable, ConsultingRoomModal, CalendarModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("number"),
          name: "number",
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.number || "";
          },
        },
        {
          title: v.$t("room"),
          name: "room",
          searchable: true,
          // width: "20%",
          data: (row) => {
            return row.room || "";
          },
        },
        {
          title: v.$t("location"),
          name: "location",
          searchable: true,
          // width: "20%",
          data: (row) => {
            return row.location || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.bed_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("profile"),
                icon: "fa fa-user",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$router.push({
                    path: `/patient/${e.detail.uuid}`,
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete bed?"),
                    v,
                    () => {
                      del("/patient/bed", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.consulting_room_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "F":
          return v.$t("free");
        case "O":
          return v.$t("occupied");
        case "M":
          return v.$t("maintenance");
        case "R":
          return v.$t("reserved");
        default:
          return status_code;
      }
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete consulting room?"),
        v,
        () => {
          del("/patient/consulting-room", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    edit(item) {
      let v = this;
      v.$refs.consulting_room_modal.edit_modal(item.uuid);
    },
    calendar(item) {
      let v = this;
      v.$refs.calendar_modal.show_modal(item.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
